<template>
  <div>
    <el-row class="el-row-topo">
      <el-col :span="24">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item>Usuários</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center">
      <el-col :span="24">
        <h1>Registro de Usuários</h1>
      </el-col>
    </el-row>
    <el-row v-if="permissao.editar_user" justify="left">
      <el-col :xs="24" :sm="24" :md="24" :lg="9" :xl="9"  style="text-align: left;">
        <h1>
          <el-button type="primary" @click="novoUsuario()" icon="el-icon-circle-plus-outline">Novo</el-button>
          <el-button type="primary" @click="atualizaSGE()" :disabled='atualiza'>Atualiza SGE</el-button>
        </h1>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="15" :xl="15">
        <el-form :inline="true" :model="formPesquisa" class="form-inline-pesquisa" style="text-align: right;">
          <el-form-item label>
            <el-input v-model="formPesquisa.pesquisa" placeholder="Pesquisa por...">
              <el-button slot="append" @click="onSubmitPesquisa" icon="el-icon-search"></el-button>
            </el-input>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="24">
        <el-table
          :data="itens"
          style="width: 100%"
          v-loading="loading"
          element-loading-text="Loading..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255, 255, 255, 0.7)"
        >
          <el-table-column prop="nome" label="Nome" min-width="260" sortable></el-table-column>
          <el-table-column prop="email" label="E-mail" min-width="290" sortable></el-table-column>
          <el-table-column prop="qtde_acessos" label="Qtde" width="80" sortable align="right"></el-table-column>
          <el-table-column label="Último Acesso" width="145" sortable :sort-by="row => row.ultimo_acesso">
            <template #default="{ row }">
              {{ formatDateTime(row.ultimo_acesso) }}
            </template>
          </el-table-column>
          <el-table-column prop="acao" label="Ação" width="150" filter-placement="bottom-end">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip
                  v-if="permissao.editar_user"
                  class="item"
                  effect="light"
                  content="Editar Senha"
                  placement="top"
                >
                  <el-button
                    size="mini"
                    type="primary"
                    @click="handleEditPass(scope.$index, scope.row)"
                    icon="el-icon-setting"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  v-if="permissao.editar_user"
                  class="item"
                  effect="light"
                  content="Editar"
                  placement="top"
                >
                  <el-button
                    size="mini"
                    type="primary"
                    @click="editUsuario(scope.row)"
                    icon="el-icon-edit"
                  ></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="light" content="Excluir" placement="top">
                  <el-button
                    v-if="permissao.excluir_user"
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)"
                    icon="el-icon-delete"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="prev, pager, next"
          background
          :total="total"
        ></el-pagination>
      </el-col>
    </el-row>
    <CadastroUsuarios
      :formCadastroUsuario="showJanela"
      :item-editado="itemEditado"
      @fechar-janela="fecharJanela"
      @salvar-item="salvarItem"
    ></CadastroUsuarios>
    <el-dialog
      id="modalEditPass"
      title="Alterar Senha"
      :visible="dialogFormVisibleEditPass"
      :show-close="false"
    >
      <el-form
        :model="ruleFormEditPass"
        :rules="rulesPass"
        ref="ruleFormEditPass"
        :label-position="labelPosition"
        class="demo-ruleForm"
      >
        <el-form-item label="Id" prop="id">
          <el-input v-model="ruleFormEditPass.id" :disabled="true"></el-input>
        </el-form-item>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="Nome" prop="nome">
              <el-input v-model="ruleFormEditPass.nome" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="Email" prop="email">
              <el-input v-model="ruleFormEditPass.email" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="Senha" prop="pass">
          <el-input type="password" v-model="ruleFormEditPass.pass" auto-complete="new-password"></el-input>
        </el-form-item>
        <el-form-item label="Repita a senha" prop="checkPass">
          <el-input
            type="password"
            v-model="ruleFormEditPass.checkPass"
            auto-complete="new-password"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleFecharEditPass()">Cancelar</el-button>
        <el-button type="primary" @click="submitFormEditPass('ruleFormEditPass')">Salvar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CadastroUsuarios from "@/components/usuarios/Cadastro.vue";
import axios from "axios";
import FuncoesUteis from "../../plugins/FuncoesUteis";

// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

export default {
  components: {
    CadastroUsuarios,
  },
  data() {
    return {
      loading: true,
      total: 0,
      pageSize: 21,
      currentPage: 1,
      atualiza: true,
      showJanela: false,
      itemEditado: null,
      itens: [],
      permissao: {},
      labelPosition: "right",
      formPesquisa: {
        pesquisa: "",
      },
      dialogFormVisibleEditPass: false,
      ruleFormEditPass: {
        id: null,
        nome: "",
        email: "",
        pass: "",
        checkPass: "",
      },
      rulesPass: {
        pass: [
          { required: true, message: "Informe a senha.", trigger: "blur" },
          {
            min: 6,
            message: "A senha deve ter pelo menos 6 caracteres.",
            trigger: "blur",
          },
        ],        
        checkPass: [
          { required: true, message: "Repita a senha.", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value !== this.ruleFormEditPass.pass) {
                callback(new Error("As senhas devem ser iguais!"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],        
      },
    };
  },
  mounted() {
    this.permissao = FuncoesUteis.isPermissao();
    if (!this.permissao.ler_user) {
      this.$message.error("Você não tem permissão para acessar esta página.");
      this.$router.push("/");
      return;
    }
    this.getDados();
  },
  methods: {
    novoUsuario() {
      this.showJanela = true;
      this.itemEditado = null;
    },
    editUsuario(row) {
      this.showJanela = true;
      this.itemEditado = { ...row };
    },
    fecharJanela() {
      this.showJanela = false;
      this.itemEditado = null;
    },
    salvarItem() {
      this.showJanela = false;
      this.itemEditado = null;
      this.getDados();
    },
    onSubmitPesquisa() {
      this.loading = true;
      let dados = {
        pesquisa: this.formPesquisa.pesquisa,
      };
      axios
        .post(url + "/userssearch/0/" + this.pageSize, dados, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((response) => {
          this.itens = response.data.dados;
          this.total = response.data.total;
          this.currentPage = 1;
        })
        .catch((err) => {
          this.$notify.error({ title: "Erro", message: "Erro ao buscar usuários: " + err });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSizeChange(size) {
      this.pageSize = size;
      const comeca_em = (this.currentPage - 1) * this.pageSize;
      this.getDados(comeca_em, this.pageSize);
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      const comeca_em = (currentPage - 1) * this.pageSize;
      this.getDados(comeca_em, this.pageSize);
    },
    getDados(paginaCorrente = 0, TamanhoPagina = this.pageSize) {
      if (this.formPesquisa.pesquisa) {
        let dados = {pesquisa: this.formPesquisa.pesquisa};
        this.loading = true;
        axios
          .post(
            url + "/userssearch/" + paginaCorrente + "/" + TamanhoPagina, dados, {
              headers: { Authorization: "Bearer " + this.$store.state.token },
            })
          .then((response) => {
            this.itens = response.data.dados;
            this.total = response.data.total;
            this.currentPage = paginaCorrente ? Math.floor(paginaCorrente / this.pageSize) + 1 : 1;
          })
          .catch((err) => {
            this.$notify.error({ title: "Erro", message: "Erro ao buscar usuários: " + err });
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.loading = true;
        axios
          .get(url + "/users/" + paginaCorrente + "/" + TamanhoPagina, {
            headers: { Authorization: "Bearer " + this.$store.state.token },
          })
          .then((response) => {
            this.itens = response.data.dados;
            this.total = response.data.total || 0;
            this.currentPage = paginaCorrente ? Math.floor(paginaCorrente / this.pageSize) + 1 : 1;
          })
          .catch((err) => {
            this.$notify.error({ title: "Erro", message: "Erro ao buscar usuários: " + err });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    handleEditPass(index, row) {
      this.dialogFormVisibleEditPass = true;
      this.ruleFormEditPass.id = row.id;
      this.ruleFormEditPass.nome = row.nome;
      this.ruleFormEditPass.email = row.email;
      this.ruleFormEditPass.pass = "";
      this.ruleFormEditPass.checkPass = "";
    },
    handleFecharEditPass() {
      this.$confirm("Tem certeza que deseja sair?", "Aviso", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning",
      })
        .then(() => {
          this.dialogFormVisibleEditPass = false;
          this.$refs.ruleFormEditPass.resetFields();
        })
        .catch(() => {});
    },
    submitFormEditPass(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let dados = { password: this.ruleFormEditPass.pass };
          axios
            .put(url + "/users/" + this.ruleFormEditPass.id, dados, {
              headers: { Authorization: "Bearer " + this.$store.state.token },
            })
            .then(() => {
              this.$notify.success({ title: "Sucesso", message: "Senha alterada com sucesso!" });
              this.$refs[formName].resetFields();
              this.getDados();
            })
            .catch((err) => {
              this.$notify.error({ title: "Erro", message: "Erro ao alterar senha: " + err });
              this.$refs[formName].resetFields();
            });
            this.dialogFormVisibleEditPass = false;
        } else {
          this.$message.error("Informe os dados corretamente!");
          return false;
        }
      });      
    },
    handleDelete(index, row) {
      this.$confirm("Tem certeza que deseja excluir este registro?", "Aviso", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancelar",
        type: "warning",
      })
        .then(() => {
          axios
            .delete(url + "/users/" + row.id, {
              headers: { Authorization: "Bearer " + this.$store.state.token },
            })
            .then(() => {
              this.$notify({
                title: "Sucesso",
                message: "Registro excluído com Sucesso!",
                type: "success",
              });
              this.getDados();
            })
            .catch((err) => {
              this.$notify.error({ title: "Erro", message: "Erro ao excluir usuário: " + err });
            });
        })
        .catch(() => {});
    },
    atualizaSGE() {
      this.atualiza = true;
      axios
        .get(url + "/usersge/", {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        })
        .then(() => {
          this.$notify.success({ title: "Sucesso", message: "Dados atualizados com sucesso!" });
          this.getDados();
        })
        .catch((err) => {
          this.$notify.error({ title: "Erro", message: "Erro ao atualizar dados: " + err });
        })
        .finally(() => {
          this.atualiza = false;
        });
    },
    formatDateTime(dateTimeStr) {
      if (!dateTimeStr) return '-';

      const date = new Date(dateTimeStr + ' UTC');
      const offset = -3 * 60;
      const localDate = new Date(date.getTime() + offset * 60 * 1000);

      const day = String(localDate.getUTCDate()).padStart(2, '0');
      const month = String(localDate.getUTCMonth() + 1).padStart(2, '0');
      const year = String(localDate.getUTCFullYear()).slice(-2);
      const hours = String(localDate.getUTCHours()).padStart(2, '0');
      const minutes = String(localDate.getUTCMinutes()).padStart(2, '0');
      const seconds = String(localDate.getUTCSeconds()).padStart(2, '0');

      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    },
  },
};
</script>

<style>
.form-inline-pesquisa {
  margin-top: 15px;
  text-align: left;
  padding-left: 50px;
}
.el-row-topo {
  margin-top: 10px;
}
</style>
